export const SLIDERTOGGLE = 'SLIDERTOGGLE'
export const EDITPASSWARD = 'EDITPASSWARD'



// WEBPACK FOOTER //
// ./src/store/toggle/types.js